// extracted by mini-css-extract-plugin
module.exports = {"header":"timeline_header__EGID9","alignedSpan":"timeline_alignedSpan__Cm1ID","alignedContainer":"timeline_alignedContainer__2VW9a"};